// @flow

import type { BuildMode } from '../types/flow/BuildMode';

export default ([
  'debug',
  'release',
]: BuildMode[]);
